import React from 'react';

const ResponsiveWrap = ({ children, ...props }) =>
  <div {...props} className="responsive-wrap">{children}</div>;

export default ResponsiveWrap;
